import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const CMSHubLogo = ({
  size,
  style,
  className
}) => {
  return /*#__PURE__*/_jsxs("svg", {
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    x: "0px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    y: "0px",
    width: size,
    height: size,
    style: style,
    className: className,
    children: [/*#__PURE__*/_jsxs("g", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: "SVGID_1_",
        x1: "1314.11121",
        x2: "1332.34998",
        y1: "939.62897",
        y2: "939.62897",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#FF7A59"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.32969",
          stopColor: "#FF8761"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.93318",
          stopColor: "#FFA875"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#FFAC78"
        })]
      }), /*#__PURE__*/_jsx("path", {
        d: "M1313.86243,945.16223L1313.86243,945.16223c0-2.32312,1.8833-4.20642,4.20642-4.20642h15.58716 c2.32312,0,4.20642,1.8833,4.20642,4.20642l0,0c0,2.32318-1.8833,4.20648-4.20642,4.20648h-15.58716 C1315.74573,949.36871,1313.86243,947.48541,1313.86243,945.16223z M1333.65601,929.88922h-4.65356 c-2.32312,0-4.20642,1.88324-4.20642,4.20642l0,0c0,2.32318,1.8833,4.20642,4.20642,4.20642h4.65356 c2.32312,0,4.20642-1.88324,4.20642-4.20642l0,0C1337.86243,931.77252,1335.97913,929.88922,1333.65601,929.88922z M1322.27527,934.09564c0-2.32312-1.88318-4.20642-4.20642-4.20642c-2.32312,0-4.20642,1.88324-4.20642,4.20642 s1.8833,4.20642,4.20642,4.20642C1320.39209,938.30206,1322.27527,936.41882,1322.27527,934.09564z",
        fill: "url(#SVGID_1_)"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "1333.65601",
        cy: "945.16223",
        fill: "#FF7A59",
        r: "4.20644"
      })]
    }), /*#__PURE__*/_jsxs("g", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        gradientUnits: "userSpaceOnUse",
        id: "SVGID_00000121999685662650023420000007641838277774055322_",
        x1: "0.24875",
        x2: "18.48749",
        y1: "12",
        y2: "12",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#FF7A59"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.32969",
          stopColor: "#FF8761"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.93318",
          stopColor: "#FFA875"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#FFAC78"
        })]
      }), /*#__PURE__*/_jsx("path", {
        d: "M0,17.5333L0,17.5333 c0-2.32316,1.88329-4.20644,4.20644-4.20644l15.58712,0C22.11671,13.32686,24,15.21015,24,17.5333v0.00001 c0,2.32315-1.88329,4.20644-4.20644,4.20643l-15.58713,0C1.88328,21.73974,0,19.85645,0,17.5333z M19.79357,2.26026l-4.65355,0 c-2.32315,0-4.20644,1.88328-4.20644,4.20643V6.4667c0,2.32315,1.88328,4.20644,4.20643,4.20644l4.65355,0 C22.11671,10.67314,24,8.78986,24,6.46671V6.4667C24,4.14355,22.11672,2.26026,19.79357,2.26026z M8.41288,6.4667 c0-2.32315-1.88329-4.20644-4.20644-4.20644S0,4.14354,0,6.4667c0,2.32315,1.88329,4.20644,4.20644,4.20644 C6.52959,10.67314,8.41288,8.78985,8.41288,6.4667z",
        fill: "url(#SVGID_00000121999685662650023420000007641838277774055322_)"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "19.79356",
        cy: "17.5333",
        fill: "#FF7A59",
        r: "4.20644"
      })]
    })]
  });
};

export default CMSHubLogo;